import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import ScrollToTop from './components/ScrollToTop';
import NewHome from './pages/NewHome';
import Agents from './pages/Agents';
import Platform from './pages/Platform';
import Industries from './pages/Industries';
import IndustryDetail from './pages/IndustryDetail';
import Pricing from './pages/Pricing';
import Demo from './pages/Demo';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SecretBackDoor from './pages/SecretBackDoor';
import { getSettingsSync } from './utils/settings';

function App() {
  const [settings, setSettings] = useState(getSettingsSync());

  useEffect(() => {
    const loadSettings = async () => {
      const { getSettings } = await import('./utils/settings');
      const fetchedSettings = await getSettings();
      setSettings(fetchedSettings);
    };
    loadSettings();
    
    const handleSettingsUpdate = () => {
      loadSettings();
    };
    
    window.addEventListener('settingsUpdated', handleSettingsUpdate);
    return () => window.removeEventListener('settingsUpdated', handleSettingsUpdate);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<NewHome />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/solutions" element={<Industries />} />
          <Route path="/solutions/:industryId" element={<IndustryDetail />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/:industryId" element={<IndustryDetail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/secretbackdoor" element={<SecretBackDoor />} />
        </Routes>
        <Footer />
        {settings.showChatWidget && <ChatWidget />}
      </BrowserRouter>
    </div>
  );
}

export default App;